"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reduxForm = require("redux-form");
var _instrumentPositionSelectors = require("../selectors/instrumentPositionSelectors");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _get = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Fields which *should* be incremented via Instrument.PriceIncrement
 *  + QuantityIncrement settings.
 */
var fieldMap = {
  limitPrice: true,
  stopPrice: true,
  quantity: true,
  trailingAmount: true,
  limitOffset: true
};
var validForms = {
  // this didn't work for Order Entry form because previous implementation of the number input
  // didn't trigger onBlur event for the input, so the middleware wasn't triggered
  // FIXME: can we remove this?
  orderEntry: false,
  advancedOrderEntry: true,
  reportBlockTrade: true
};

/**
 * Snap form values to Instrument.PriceIncrement.
 * TODO: why do we need this middleware? Does it work in any other cases?
 */
var priceQuantityIncrementMiddleware = function priceQuantityIncrementMiddleware(store) {
  return function (next) {
    return function (action) {
      if (action.type === '@@redux-form/BLUR' && validForms[(0, _get["default"])(action, 'meta.form')] && fieldMap[(0, _get["default"])(action, 'meta.field')]) {
        var state = store.getState();
        var _selectedInstrumentSe = (0, _instrumentPositionSelectors.selectedInstrumentSelector)(state),
          PriceIncrement = _selectedInstrumentSe.PriceIncrement,
          QuantityIncrement = _selectedInstrumentSe.QuantityIncrement;
        var Increment = action.meta.field === 'quantity' ? QuantityIncrement : PriceIncrement;
        var val = (0, _reduxForm.formValueSelector)(action.meta.form)(state, action.meta.field);
        var incrementedVal = (0, _decimalPlacesHelper.incrementUiValue)(val, Increment);
        if (val !== incrementedVal) {
          store.dispatch((0, _reduxForm.change)(action.meta.form, action.meta.field, incrementedVal));
        }
      }
      return next(action);
    };
  };
};
var _default = exports["default"] = priceQuantityIncrementMiddleware;